import type { MobileProps } from "~/components/header/index"
import Icon from "~/components/ui/Icon"
import CartIndicator from "~/components/cart/Indicator"
import Searchbar from "~/components/search/Searchbar"
import Logo from "~/components/header/logo/index"
import MobileMenu from "~/components/header/menu/index"

export default function MobileHeader({
    contacts,
    links,
    mobileAlert,
    menu,
    searchbar,
    navItems,
    logo,
    isHome,
}: MobileProps) {
    return (
        <>
            {mobileAlert && (
                <div
                    className='flex items-center justify-center p-1 text-center text-white texte-[10px] bg-black min-h-8'
                    dangerouslySetInnerHTML={{ __html: mobileAlert }}
                />
            )}

            <header className='px-3 py-4 bg-wine'>
                <div className='flex items-center justify-between select-none'>
                    <div>
                        <input id='header-mobile-menu' type='checkbox' className='fixed hidden peer' />

                        <label
                            htmlFor='header-mobile-menu'
                            className='flex items-center justify-center w-12 h-12'
                        >
                            <Icon className='text-white' id='Menu' size={36} role='img' aria-label='Abrir menu' />
                        </label>

                        <MobileMenu
                            menu={menu}
                            contacts={contacts}
                            links={links}
                            navItems={navItems}
                        />
                    </div>

                    <Logo isHome={isHome} logo={logo} />

                    <div>
                        <a
                            href='/checkout/#/cart'
                            className='relative flex items-center justify-center w-12 h-12 text-white'
                            rel='nofollow'
                        >
                            {/* Ver cart/Button.tsx: nome composto pelo conteúdo
                                para o badge de quantidade não ser engolido. */}
                            <span className='sr-only'>Sacola</span>
                            <Icon id='Sacola' size={36} className='text-orange' />

                            <div className='absolute -bottom-[7%] -right-[2%]'>
                                <CartIndicator />
                            </div>
                        </a>
                    </div>
                </div>

                <div className='mt-3 text-white'>
                    <Searchbar {...searchbar} isMobile={true} />
                </div>
            </header>
        </>
    )
}
